import { Spinner } from "@heroui/react";
import { motion } from "framer-motion";


const Loader = () => {
  
  return (
    <div className="flex flex-col justify-center items-center w-full h-screen bg-white dark:bg-zinc-900">
      {/* Icône animée */}
      <motion.div 
        animate={{ rotate: 360 }} 
        transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
        className="mb-4"
      >
        <Spinner size={"md"} className="text-primary" />
      </motion.div>

      {/* Texte de chargement */}
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, repeat: Infinity, repeatType: "reverse" }}
        className="font-semibold text-gray-600 dark:text-gray-300"
      >
        Chargement en cours...
      </motion.p>

      {/* Barre de progression */}
      {/* <Progress
        isIndeterminate
        aria-label="Chargement..."
        size="sm"
        className="mt-4 w-2/3"
        color="primary"
      /> */}
    </div>
  );
};

export default Loader;
